<template>
  <main class="redirect-page">
    <section class="redirect-page__container">
      <div class="redirect-page__logo">
        <a href="https://www.norli.dk/">
          <inline-svg class="logo" :src="usePrefixAssetUrl(norligLogo)" width="150" height="30" aria-label="Norli logo" />
        </a>
      </div>

      <h1>Tak for besøget</h1>

      <p class="redirect-page__message">
        Du vil blive viderestillet til
        <a href="https://www.norli.dk/" class="redirect-page__login-link">norli.dk</a>
        om et øjeblik.
      </p>
    </section>
  </main>
</template>
<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue'
import norligLogo from '@/assets/svg/norli-logo.svg'
import { usePrefixAssetUrl } from '@/composables/usePrefixAssetUrl'

const REDIRECT_URL = 'https://www.norli.dk/'
const REDIRECT_AFTER_SECONDS = 5

let timeoutId: number | undefined

onMounted(() => {
  timeoutId = window.setTimeout(() => {
    window.location.href = REDIRECT_URL
  }, REDIRECT_AFTER_SECONDS * 1000)
})

onBeforeUnmount(() => {
  if (timeoutId !== undefined) window.clearTimeout(timeoutId)
})
</script>